import getButtons from './buttons';
import Purchase from '../Purchase';

class PurchasedDigital extends Purchase {
    constructor(store, data) {
        super(store, data);
        this.track = null;
        this.isDigital = true;
        this.items = [{ item: this.data.digital }];
        this.digital = this.data.digital;
        this.items[0].url = `/courses/${this.digital.url}`;
        this.name = this.data.digital.name;
        this.price = this.items.reduce((acc, item) => {
            return acc + item.item.price;
        }, 0)
    }

    updateFromJson(json) {
    }

    get status() {
        return null;
    }

    get buttons() {
        return getButtons(this);
    }

    get hasWebinarLink() {
        return this.digital.webinarLink && this.digital.webinarLink !== '';
    }

    get hasTelegramChannel() {
        return this.digital.link && this.digital.link !== '';
    }
}

export default PurchasedDigital;
